import moment from 'moment'

export const DAILY_LOG_PAGE_SIZE = 10

const DAILY_LOG_TYPE_META = {
  STUDY: { label: '학습', tone: 'study' },
  REST: { label: '휴식', tone: 'rest' },
  MEAL: { label: '식사', tone: 'meal' },
  ETC: { label: '기타', tone: 'etc' },
  ATTENDANCE: { label: '출석', tone: 'attendance' },
  SLEEP: { label: '수면', tone: 'rest' },
}

export function getDailyLogTypeMeta(type) {
  return DAILY_LOG_TYPE_META[type] || { label: type || '기타', tone: 'etc' }
}

export function normalizeDailyLogTypes(types = []) {
  const normalized = types.map((type) => {
    const rawValue = typeof type === 'string' ? type : type.code
      || type.value
      || type.dailyLogType
      || type.dailyLogTypeNameEn?.toUpperCase()
    const value = rawValue?.toUpperCase()
    const fallback = getDailyLogTypeMeta(value)
    return {
      value,
      label: typeof type === 'string' ? fallback.label : type.label || type.dailyLogTypeNameKo || fallback.label,
    }
  }).filter(({ value }) => value && value !== 'ATTENDANCE')

  const uniqueTypes = [...new Map(normalized.map((type) => [type.value, type])).values()]

  return uniqueTypes.length > 0
    ? uniqueTypes
    : ['STUDY', 'REST', 'MEAL', 'SLEEP', 'ETC'].map((value) => ({
      value,
      label: getDailyLogTypeMeta(value).label,
    }))
}

export function filterDailyLogs(logs, { query = '', type = 'ALL' } = {}) {
  const normalizedQuery = query.trim().toLocaleLowerCase('ko')

  return [...(logs || [])]
    .filter((log) => type === 'ALL' || log.dailyLogType === type)
    .filter((log) => {
      if (!normalizedQuery) return true
      const typeLabel = getDailyLogTypeMeta(log.dailyLogType).label
      return `${log.contents || ''} ${typeLabel}`
        .toLocaleLowerCase('ko')
        .includes(normalizedQuery)
    })
    .sort((a, b) => String(a.activityTime?.startOn || '').localeCompare(String(b.activityTime?.startOn || '')))
}

export function paginateDailyLogs(logs, page, pageSize = DAILY_LOG_PAGE_SIZE) {
  const totalPages = Math.max(1, Math.ceil(logs.length / pageSize))
  const safePage = Math.min(Math.max(page, 0), totalPages - 1)
  const start = safePage * pageSize

  return {
    page: safePage,
    totalPages,
    start,
    end: Math.min(start + pageSize, logs.length),
    items: logs.slice(start, start + pageSize),
  }
}

export function getActivityDurationSeconds(log) {
  const start = moment(log?.activityTime?.startOn)
  const end = moment(log?.activityTime?.endOn)
  if (!start.isValid() || !end.isValid()) return 0
  return Math.max(0, end.diff(start, 'seconds'))
}

export function formatLogDuration(log) {
  const seconds = log?.dailyLogType === 'STUDY'
    ? Number(log?.activityTime?.focusTimeSec || 0)
    : getActivityDurationSeconds(log)
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainder = seconds % 60
  const prefix = log?.dailyLogType === 'STUDY' ? '집중 ' : ''

  if (hours > 0) return `${prefix}${hours}시간 ${minutes}분`
  if (minutes > 0) return `${prefix}${minutes}분`
  return `${prefix}${remainder}초`
}

export function formatActivityRange(log) {
  const start = moment(log?.activityTime?.startOn)
  const end = moment(log?.activityTime?.endOn)
  if (!start.isValid() || !end.isValid()) return '시간 정보 없음'
  return `${start.format('HH:mm')}–${end.format('HH:mm')}`
}

